import BaseElement from './BaseElement';
import HealthscoreReportHistory from '../Components/Profile/HealthscoreReportHistory';
class HealthscoreReportHistoryElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = HealthscoreReportHistory;
    }
}
export const loadHealthscoreReportHistoryElement = () => {
    customElements.define('healthscore-report-history', HealthscoreReportHistoryElement);
};
